import {
  UserState,
  UserActionTypes,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  WORLD_SELECT,
  EXPLORATION_SUCCESS,
  BUY_WORLD,
  SHOW_ALERT,
  SHOW_LOADING,
  HIDE_LOADING,
  STAKE_SUCCESS,
  CLAIM_STAKE,
  BUY_GOLD,
  GET_LEADERBOARD,
  LEVELUP_SUCCESS,
  LEVELUP_BOOST_SUCCESS,
  GET_TOURNAMENT_LIST,
  STAKE_TOOL_SUCCESS,
  GET_EXPLORATIONS,
  CLAIM_EXPLORATION_SUCCESS,
  ENTER_TOURNAMENT_SUCCESS,
  GET_GAME_STATUS,
  GET_GAME_STATUS_SUCCESS,
  GET_GAME_STATUS_FAILURE,
  GET_ASSETS,
  GET_ASSETS_SUCCESS,
  GET_ASSETS_FAILURE,
} from "./action-types";

const initialState: UserState = {
  loginInfo: {
    session: null,
    account: "",
    balance: {
      wax_balance: "0 WAX",
      gold_balance: "0 GOLD",
      grass_balance: "0 GRASS",
      antler_balance: "0 ANTLER",
    },
    assets: null,
    isLogin: false,
    open_worlds: [1],
    staking_pool: [],
    tool_configs: [],
    deer_configs: [],
  },

  gameStatus: {
    world_cost: [],
    reward_info: [],
    pool_info: [],
    leaderboard: [],
    tournaments: [],
    myScore: null,
    world: 0,

    alert: {
      type: "success",
      message: "",
      show: false,
    },

    loading: false,
    worldsInfo: [],
    openWorlds: [1],
    explorations: [],
    completedExplorations: [],
    activeExplorations: [],
    lastUpdated: null,
    error: null,
  },

  assetData: {
    toolConfigs: [],
    deerConfigs: [],
    stakingPools: [],
    tools: [],
    deers: [],
    lastUpdated: null,
    loading: false,
    error: null,
  },
};

export function userReducer(state = initialState, action: any): UserState {
  switch (action.type) {
    case LOGIN_REQUEST: {
      const { loginInfo, gameStatus } = { ...state };
      loginInfo.isLogin = false;

      return { loginInfo, gameStatus , assetData: state.assetData };
    }
    case LOGIN_SUCCESS: {
      const {
        session,
        balance,
        assets,
        world_cost,
        open_worlds,
        reward_info,
        pool_info,
        staking_pool,
        tool_configs,
        deer_configs,
      } = action.payload;

      const { loginInfo, gameStatus } = { ...state };

      loginInfo.isLogin = session ? true : false;
      loginInfo.session = session;
      loginInfo.account = session
        ? session.permissionLevel.actor.toString()
        : "";
      loginInfo.assets = assets;
      loginInfo.balance = balance;
      loginInfo.open_worlds = open_worlds;
      loginInfo.open_worlds.push(1);
      loginInfo.staking_pool = staking_pool;
      loginInfo.tool_configs = tool_configs;
      loginInfo.deer_configs = deer_configs;

      gameStatus.world_cost = world_cost;
      gameStatus.reward_info = reward_info;

      gameStatus.pool_info = pool_info?.map((item: any) => {
        let _item = { ...item };

        let staked_pool = staking_pool?.find(
          (pool: any) => pool.pool_id == _item.id
        );
        if (staked_pool) {
          _item = { ..._item, ...staked_pool };
          _item["is_staked"] = true;
        }

        return _item;
      });
            return { loginInfo, gameStatus , assetData: state.assetData };

    }

    case LOGIN_ERROR: {
      const { error } = action.payload;
      const { loginInfo, gameStatus } = { ...state };
      loginInfo.isLogin = false;

            return { loginInfo, gameStatus , assetData: state.assetData };

    }

    case BUY_WORLD: {
      const { world } = action.payload;

      const { loginInfo, gameStatus } = { ...state };

      loginInfo.open_worlds.push(world);

            return { loginInfo, gameStatus , assetData: state.assetData };

    }

    case WORLD_SELECT: {
      const { world } = action.payload;

      const { loginInfo, gameStatus } = { ...state };

      gameStatus.world = world;

            return { loginInfo, gameStatus , assetData: state.assetData };

    }

    case EXPLORATION_SUCCESS: {
      const { asset_ids, type } = action.payload;

      const { loginInfo, gameStatus } = { ...state };

            return { loginInfo, gameStatus , assetData: state.assetData };

    }

    case STAKE_TOOL_SUCCESS: {
      const { ids, type } = action.payload;
      const { loginInfo, gameStatus } = { ...state };

      loginInfo.assets = loginInfo.assets?.map((item: any) => {
        const new_item = { ...item };

        const isPresent = ids?.includes(item.asset_id);
        if (isPresent) {
          const currentUnixTime = Math.floor(new Date().getTime() / 1000);
          new_item.exploration_time = currentUnixTime + 86400;
        }

        return new_item;
      });

            return { loginInfo, gameStatus , assetData: state.assetData };

    }

    case STAKE_SUCCESS: {
      const { pool_id, amount } = action.payload;
      const { loginInfo, gameStatus } = { ...state };

      gameStatus.pool_info = gameStatus.pool_info?.map((pool: any) => {
        if (pool.id == pool_id) {
          const currentUnixTime = Math.floor(new Date().getTime() / 1000);

          pool.is_staked = true;
          pool.cooldown_until = currentUnixTime + pool.stake_delay;
          pool.balance = amount;
        }
        return pool;
      });

            return { loginInfo, gameStatus , assetData: state.assetData };

    }

    case CLAIM_STAKE: {
      const { pool_id } = action.payload;
      const { loginInfo, gameStatus } = { ...state };

      gameStatus.pool_info = gameStatus.pool_info?.map((pool: any) => {
        if (pool.id == pool_id) pool.is_staked = false;
        return pool;
      });

            return { loginInfo, gameStatus , assetData: state.assetData };

    }

    case BUY_GOLD: {
      const { amount, receive_amount } = action.payload;
      const { loginInfo, gameStatus } = { ...state };

      loginInfo.balance.wax_balance =
        parseFloat(loginInfo.balance.wax_balance) - amount + "WAX";
      loginInfo.balance.wax_balance =
        parseFloat(loginInfo.balance.gold_balance) + receive_amount + "GOLD";

            return { loginInfo, gameStatus , assetData: state.assetData };

    }

    case GET_LEADERBOARD: {
      const { leaderboard, myScore } = action.payload;
      const { loginInfo, gameStatus } = { ...state };

      gameStatus.leaderboard = leaderboard;
      gameStatus.myScore = myScore;

            return { loginInfo, gameStatus , assetData: state.assetData };

    }

    case LEVELUP_SUCCESS: {
      const { asset_id, current_level } = action.payload;
      const { loginInfo, gameStatus } = { ...state };

      // let delay = current_level * current_level * 30 * 10;

      // loginInfo.assets = loginInfo.assets.map((item: any) => {
      //   if (item.asset_id == asset_id) {
      //     item.level = current_level + 1;
      //     const currentUnixTime = Math.floor(new Date().getTime() / 1000);
      //     item.upgrade_end_at = currentUnixTime + delay;
      //   }
      //   return item;
      // });

      return { loginInfo, gameStatus , assetData: state.assetData };

    }

    case LEVELUP_BOOST_SUCCESS: {
      const { asset_id, boostAmount } = action.payload;
      const { loginInfo, gameStatus } = { ...state };

      loginInfo.assets = loginInfo.assets.map((item: any) => {
        if (item.asset_id == asset_id) {
          item.upgrade_end_at = item.upgrade_end_at - boostAmount * 60;
        }
        return item;
      });

            return { loginInfo, gameStatus , assetData: state.assetData };

    }

    case ENTER_TOURNAMENT_SUCCESS: {
      const { id } = action.payload;
      const { loginInfo, gameStatus } = { ...state };

      gameStatus.tournaments = gameStatus.tournaments.map((item: any) => {
        if (item.id == id) {
          item.is_entered = true;
        }

        return item;
      });

      // Update the loginInfo to reflect the entered tournament
      return { loginInfo, gameStatus , assetData: state.assetData };

    }

    case GET_TOURNAMENT_LIST: {
      const { tournaments } = action.payload;
      const { loginInfo, gameStatus } = { ...state };

      if (!Array.isArray(tournaments) || tournaments.length === 0) {
        gameStatus.tournaments = [];
        return { loginInfo, gameStatus, assetData: state.assetData };
      }

      gameStatus.tournaments = tournaments.map((item: any) => {
        const entries = Array.isArray(item.entries) ? item.entries : [];
        const is_entered = Array.isArray(entries) && entries.map((entry: any) => {
          return entry.player === loginInfo.account;
        }).includes(true);

        const hasResults = !!item.results && typeof item.results === "object";
        const final = hasResults ? item.results : null;
        const is_open = item.reg_start <= Math.floor(Date.now() / 1000) && item.reg_end >= Math.floor(Date.now() / 1000);

        const is_started = item.start_time <= Math.floor(Date.now() / 1000);
        const is_ended = item.end_time <= Math.floor(Date.now() / 1000);

        // Improved winner detection logic
        let winner1 = "";
        let winner2 = "";
        
        if (hasResults && final) {
          // Try different possible result structures
          winner1 = final.winner || final.winner1 || final.first_place || "";
          winner2 = final.runner_up || final.winner2 || final.second_place || final.runner_up || "";
          
          // If no winners in results, check if there are matches with winners
          if (!winner1 && Array.isArray(item.matches)) {
            const matchesWithWinners = item.matches.filter((match: any) => 
              match.players?.[0]?.winner || match.winner
            );
            if (matchesWithWinners.length > 0) {
              // Get the last match winner as the tournament winner
              const lastMatch = matchesWithWinners[matchesWithWinners.length - 1];
              winner1 = lastMatch.players?.[0]?.winner || lastMatch.winner || "";
            }
          }
        }

        return {
          ...item,
          is_entered,
          is_open,
          is_ended,
          is_started,
          winner1,
          winner2,
        };
      });
      return { loginInfo, gameStatus, assetData: state.assetData };
    }

    case SHOW_ALERT: {
      const { type, msg, show } = action.payload;

      const { loginInfo, gameStatus } = { ...state };

      gameStatus.alert = {
        show: show,
        type: type,
        message: msg,
      };

            return { loginInfo, gameStatus , assetData: state.assetData };

    }

    case SHOW_LOADING: {
      const { loginInfo, gameStatus } = { ...state };
      gameStatus.loading = true;
            return { loginInfo, gameStatus , assetData: state.assetData };

    }

    case HIDE_LOADING: {
      const { loginInfo, gameStatus } = { ...state };
      gameStatus.loading = false;
            return { loginInfo, gameStatus , assetData: state.assetData };

    }

    case GET_EXPLORATIONS: {
      const { explorations } = action.payload;
      const { loginInfo, gameStatus } = { ...state };

      gameStatus.explorations = explorations;

            return { loginInfo, gameStatus , assetData: state.assetData };

    }

    case CLAIM_EXPLORATION_SUCCESS: {
      const { exploreId } = action.payload;
      const { loginInfo, gameStatus } = { ...state };

      // Remove the claimed exploration from the list
      gameStatus.explorations = gameStatus.explorations.filter(
        (exp: any) => exp.id !== exploreId
      );

      return { loginInfo, gameStatus , assetData: state.assetData };
    }

    case GET_GAME_STATUS: {
      const { loginInfo, gameStatus, assetData } = { ...state };
      gameStatus.loading = true;
      return { loginInfo, gameStatus, assetData };
    }

    case GET_GAME_STATUS_SUCCESS: {
      const { worldsInfo, openWorlds, explorations, completedExplorations, activeExplorations, lastUpdated } = action.payload;
      const { loginInfo, gameStatus, assetData } = { ...state };
      
      gameStatus.worldsInfo = worldsInfo;
      gameStatus.openWorlds = openWorlds;
      gameStatus.explorations = explorations;
      gameStatus.completedExplorations = completedExplorations;
      gameStatus.activeExplorations = activeExplorations;
      gameStatus.lastUpdated = lastUpdated;
      gameStatus.loading = false;
      gameStatus.error = null;
      
      return { loginInfo, gameStatus, assetData };
    }

    case GET_GAME_STATUS_FAILURE: {
      const { error } = action.payload;
      const { loginInfo, gameStatus, assetData } = { ...state };
      
      gameStatus.loading = false;
      gameStatus.error = error;
      
      return { loginInfo, gameStatus, assetData };
    }

    case GET_ASSETS: {
      const { loginInfo, gameStatus, assetData } = { ...state };
      assetData.loading = true;
      return { loginInfo, gameStatus, assetData };
    }

    case GET_ASSETS_SUCCESS: {
      const { toolConfigs, deerConfigs, stakingPools, tools, deers, lastUpdated } = action.payload;
      const { loginInfo, gameStatus, assetData } = { ...state };
      
      assetData.toolConfigs = toolConfigs;
      assetData.deerConfigs = deerConfigs;
      assetData.stakingPools = stakingPools;
      assetData.tools = tools;
      assetData.deers = deers;
      assetData.lastUpdated = lastUpdated;
      assetData.loading = false;
      assetData.error = null;
      
      return { loginInfo, gameStatus, assetData };
    }

    case GET_ASSETS_FAILURE: {
      const { error } = action.payload;
      const { loginInfo, gameStatus, assetData } = { ...state };
      
      assetData.loading = false;
      assetData.error = error;
      
      return { loginInfo, gameStatus, assetData };
    }

    default:
      return { ...state };
  }
}
